
import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import Dates from '../Dates';
import translate from '../../../utils/translations';
import BackgroundImageCDN from '../../../components/BackgroundImageCDN';
import { prefixPath } from '../../../utils/prefixPath';

const BlogListItem = ({ item, pathAlias, langcode }) => {
    if (!item) {
        return '';
    }

    const backgroundImage = _get(item, 'relationships.field_lead_image.relationships.field_media_image');
    const leadText = _get(item, 'field_lead_text');
    const categories = _get(item, 'relationships.field_category');
    const tags = _get(item, 'relationships.field_tags') || [];
    const uid = _get(item, 'relationships.uid') || {};

    return (

        <div className="list-item events blog">
            <a href={prefixPath(pathAlias, langcode)} >
                <BackgroundImageCDN
                    image={backgroundImage}
                    imageStyleFilterKey={'card'}
                    className="card-image-wrapper"
                    style={{
                        backgroundImage
                    }}
                />
            </a>

            <div className="list-item-inner">
                <a href={prefixPath(pathAlias, langcode)} >
                    <h2 className="list-item-title">
                        {item.title}
                    </h2>
                </a>
                <div className="list-item-category">
                    {
                        categories ?
                            categories.map(category => (
                                <a href={prefixPath(category.path.alias, langcode)} className="list-item-category-item" key={category.id}>
                                    {category.name}
                                </a>
                            ))
                            : ''
                    }
                </div>

                <Dates
                    fromDate={item.created}
                    hideTime={true}
                    showWeekday={true}
                />
                <a href={prefixPath(pathAlias, langcode)}
                    className="list-item-further-information"
                    aria-label={item.title}
                >
                    <ArrowForwardIcon />
                </a>

                <div className="list-item-summary">
                    {leadText || ''}
                    {
                        uid.display_name ?
                            <div className="list-item-author">
                                {translate('by', langcode)}&nbsp;
                                {uid.path && uid.path.alias ?
                                    <a href={uid.path.alias} key={uid.id}>
                                        {uid.display_name}
                                    </a> : uid.display_name}
                            </div> : ''
                    }
                </div>


                {
                    tags.length ?
                        <div className="blog-tags">
                            <div className="list-item-blog-title">{translate('tags', langcode)}:&nbsp;</div>
                            <div className="blog-tags-tag">
                                {tags.map(tag => (
                                    <span key={tag.id}> <a href={prefixPath(tag.path.alias, langcode)}
                                        className="list-item-category-item list-item-blog-item">
                                        {tag.name}
                                    </a></span>
                                ))}
                            </div>
                        </div>
                        : ''
                }
            </div>
        </div>
    );
};

export default BlogListItem;

BlogListItem.propTypes = {
    item: PropTypes.objectOf(PropTypes.any).isRequired,
    pathAlias: PropTypes.string.isRequired,
    langcode: PropTypes.string
};
